import { useGetGeoSheetPreviewQuery, useGetGeoSheetSnapsQuery } from '@shared/api';
import type { GeoScheme, GeoSnapPoint } from '@entities/geodesy';
import { useObjectUrl } from '@widgets/GeoSchemes';

/** URL превью текущей страницы проектного листа (байты — через RBAC-запрос). */
export function useSheetPreviewUrl(scheme: GeoScheme) {
  const sheet = scheme.sheet;
  const { data, isFetching, isError } = useGetGeoSheetPreviewQuery(
    { id: scheme.id, fileId: sheet?.file_id ?? '', page: sheet?.page ?? 0 },
    { skip: !sheet },
  );
  const url = useObjectUrl(sheet ? data : null);
  return { url, isFetching, isError };
}

/** Точки прилипания листа и состояние их загрузки (для `SheetPointPicker`). */
export interface SheetSnaps {
  points: GeoSnapPoint[];
  warnings: string[];
  loading: boolean;
  /** Не загрузились (нет векторной графики, сервис недоступен) — ставим по картинке. */
  failed: boolean;
}

const NO_POINTS: GeoSnapPoint[] = [];
const NO_WARNINGS: string[] = [];

export function useSheetSnaps(scheme: GeoScheme, enabled: boolean): SheetSnaps {
  const sheet = scheme.sheet;
  const { data, isFetching, isError } = useGetGeoSheetSnapsQuery(
    { id: scheme.id, fileId: sheet?.file_id ?? '', page: sheet?.page ?? 0 },
    { skip: !sheet || !enabled },
  );
  return {
    points: data?.points ?? NO_POINTS,
    warnings: data?.warnings ?? NO_WARNINGS,
    loading: isFetching && !data,
    failed: isError && !data,
  };
}

/** Единицы листа по-русски. */
export function unitsLabel(units: string): string {
  switch (units.toLowerCase()) {
    case 'pt':
      return 'pt';
    case 'mm':
      return 'мм';
    case 'cm':
      return 'см';
    case 'm':
      return 'м';
    case 'in':
    case 'inch':
      return 'дюйм';
    default:
      return units;
  }
}
